module.exports = __webpack_public_path__ + "static/img/sina.9622080.png";


//////////////////
// WEBPACK FOOTER
// ./static/sina.png
// module id = HCQD
// module chunks = 1